// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: #b19cd9;
  color: #ffffff;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.centerText {
  text-align: center;
}

.container {
  width: 100%;
  padding: 20px;
  border-radius: 8px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.card {
  border: none;
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.3s ease;
  height: 100%;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  margin-bottom: 15px;
}

.card:hover {
  transform: translateY(-8px);
  box-shadow: 0 16px 32px rgba(0, 0, 0, 0.3);
}

.card-image-container {
  padding: 15px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 140px;
  overflow: hidden;
}

.card-image {
  max-width: 100%;
  max-height: 110px;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.card:hover .card-image {
  transform: scale(1.05);
}

.card-header {
  background-color: #51265d;
  color: #fff;
  font-weight: bold;
  padding: 12px 15px;
  font-size: 1rem;
  border-bottom: none;
}

.card-body {
  background-color: #dcd6f7;
  color: #333;
  padding: 15px;
  font-size: 0.9rem;
}

/* Responsive adjustments */
@media (max-width: 576px) {
  .card {
    margin-bottom: 20px;
  }
  
  .card-header {
    font-size: 0.9rem;
    padding: 10px;
  }
  
  .card-body {
    padding: 12px;
    font-size: 0.8rem;
  }
  
  .card-image-container {
    height: 120px;
  }

  h1 {
    font-size: 1.6rem;
  }
}

/* For medium devices (tablets) */
@media (min-width: 768px) and (max-width: 991px) {
  .card-header {
    font-size: 0.95rem;
  }
}

/* For large screens - make cards appear in a grid */
@media (min-width: 1200px) {
  .hub_container {
    max-width: 2500px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Home.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,cAAc;EACd,4DAA4D;AAC9D;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,0CAA0C;EAC1C,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA,oDAAoD;AACpD;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":["body {\n  background-color: #b19cd9;\n  color: #ffffff;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.centerText {\n  text-align: center;\n}\n\n.container {\n  width: 100%;\n  padding: 20px;\n  border-radius: 8px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.card {\n  border: none;\n  border-radius: 16px;\n  overflow: hidden;\n  transition: all 0.3s ease;\n  height: 100%;\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n  cursor: pointer;\n  margin-bottom: 15px;\n}\n\n.card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 16px 32px rgba(0, 0, 0, 0.3);\n}\n\n.card-image-container {\n  padding: 15px;\n  background-color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 140px;\n  overflow: hidden;\n}\n\n.card-image {\n  max-width: 100%;\n  max-height: 110px;\n  object-fit: contain;\n  transition: transform 0.3s ease;\n}\n\n.card:hover .card-image {\n  transform: scale(1.05);\n}\n\n.card-header {\n  background-color: #51265d;\n  color: #fff;\n  font-weight: bold;\n  padding: 12px 15px;\n  font-size: 1rem;\n  border-bottom: none;\n}\n\n.card-body {\n  background-color: #dcd6f7;\n  color: #333;\n  padding: 15px;\n  font-size: 0.9rem;\n}\n\n/* Responsive adjustments */\n@media (max-width: 576px) {\n  .card {\n    margin-bottom: 20px;\n  }\n  \n  .card-header {\n    font-size: 0.9rem;\n    padding: 10px;\n  }\n  \n  .card-body {\n    padding: 12px;\n    font-size: 0.8rem;\n  }\n  \n  .card-image-container {\n    height: 120px;\n  }\n\n  h1 {\n    font-size: 1.6rem;\n  }\n}\n\n/* For medium devices (tablets) */\n@media (min-width: 768px) and (max-width: 991px) {\n  .card-header {\n    font-size: 0.95rem;\n  }\n}\n\n/* For large screens - make cards appear in a grid */\n@media (min-width: 1200px) {\n  .hub_container {\n    max-width: 2500px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
